module.exports = __webpack_public_path__ + "assets/ic_phone-976a6e.svg";